<template>
  <div>
    <div class="header_box">
      <div class="header">
        <div
          class="count-wrap"
          v-if="countDownNum"
          :class="{ 'count-en-warp': langSet != 'cn' || !isNav }"
        >
          <div class="count-num">
            <countdown :endDate="countDownNum"></countdown>
          </div>
          <div class="num" v-if="isNav">
            {{ langSet == "cn" ? "倒计时" : "Countdown" }}
          </div>
          <div class="num" v-else>カウントダウン</div>
        </div>
        <div v-if="logo && isNav" class="header-logo" @click="toLink('/')">
          <img :src="logo" alt="" />
        </div>
        <navMenu
          v-if="isNav"
          class="navcenter"
          @changjqqd="changjqqd"
        ></navMenu>
        <div class="header-right">
          <div class="languagewrap" @click="changeLang">
            <img
              class="right-icon"
              :src="require('../assets/icon_lang.png')"
              alt=""
            />
            <el-select
              v-model="value"
              :placeholder="langSet == 'cn' ? '语言' : 'Language'"
              @change="changeLang"
              popper-class="dropdown_sel"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="
                  isNav
                    ? langSet == 'cn'
                      ? item.label_cn
                      : item.label_en
                    : item.label_jp
                "
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <template v-if="isNav">
            <img
              v-if="!flag"
              class="header-user"
              :src="user"
              alt=""
              @click="toLink('/login')"
            />
          </template>
          <template v-if="flag">
            <div
              class="header_login flex flex_items_center flex_content_center"
              :class="isShowInfo ? 'show' : ''"
              @click="showInfo"
            >
              <img :src="userInfo.avatar" alt="" />
              <i class="el-icon-arrow-right"></i>
            </div>
            <div class="login_wrap" v-if="isShowInfo">
              <div class="login_top">
                <img :src="userInfo.avatar" alt="" />
                <div class="login_info">
                  <div class="name">
                    {{ userInfo.nickname }}<span>{{ userInfo._duties }}</span>
                  </div>
                  <div>{{ userInfo.companyName }}</div>
                </div>
              </div>
              <div class="login_middle">
                <div class="login_item" @click="toLink('/personal')">
                  <img class="icon_a" src="../assets/icon_p.png" alt="" />
                  <img class="icon_d" src="../assets/icon_pa.png" alt="" />
                  <p>
                    {{ langSet == "cn" ? "个人资料" : "Personal Information" }}
                  </p>
                </div>
                <div class="login_item" @click="toLink('/mycollect')">
                  <img class="icon_a" src="../assets/icon_c.png" alt="" />
                  <img class="icon_d" src="../assets/icon_ca.png" alt="" />
                  <p>{{ langSet == "cn" ? "我的收藏" : "My Favourite" }}</p>
                </div>
                <div class="login_item" @click="toLink('/mybusiness')">
                  <img class="icon_a" src="../assets/icon_b.png" alt="" />
                  <img class="icon_d" src="../assets/icon_ba.png" alt="" />
                  <p>{{ langSet == "cn" ? "我的商机" : "My Business" }}</p>
                </div>
                <div class="login_item" @click="toLink('/feedback')">
                  <img class="icon_a" src="../assets/icon_fa.jpg" alt="" />
                  <img class="icon_d" src="../assets/icon_f.jpg" alt="" />
                  <p>
                    {{ langSet == "cn" ? "评价与反馈" : "Comment/ Feedback" }}
                  </p>
                </div>
              </div>
              <div class="login_bottom">
                <div class="text" @click="handleDialogVisible">
                  {{ langSet == "cn" ? "认证展商" : "Certified Exhibitors" }}
                </div>
                <div @click="logOut">
                  {{ langSet == "cn" ? "退出登录" : "Log Out" }}
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="mobile-header-box">
      <el-row class="mobile-header">
        <el-col :xs="1" :sm="1"></el-col>
        <el-col :xs="2" :sm="2">
          <div class="header-menu">
            <img @click="showMenu" src="../assets/imgs/menu_icon.jpg" alt="" />
          </div>
        </el-col>
        <el-col :xs="1" :sm="1"></el-col>
        <el-col :xs="19" :sm="14">
          <div v-if="logoH5" class="header-logo" @click="toLink('/')">
            <img :src="logoH5" alt="" />
          </div>
        </el-col>
        <div class="count-wrap" v-if="countDownNum">
          <div class="count-num">
            <countdown :endDate="countDownNum"></countdown>
          </div>
          <div class="num">{{ langSet == "cn" ? "倒计时" : "Countdown" }}</div>
        </div>
      </el-row>
      <moblienavMenu v-if="!isShowMenu" @closeMenu="closeMenu"></moblienavMenu>
    </div>
    <div class="height"></div>
    <el-dialog
      :close-on-click-modal="false"
      class="dialog"
      :visible.sync="dialogVisible"
    >
      <img class="dialog_img" src="../assets/jqqd.jpg" />
      <div class="dialog_txt">
        {{ showtype == 0 ? "Stay Tuned" : "敬请期待" }}
      </div>
    </el-dialog>
    <el-dialog
      width="400px"
      custom-class="exhibition_dialog"
      :visible.sync="dialogVisibleEx"
      :modal-append-to-body="false"
      :show-close="false"
      :z-index="3000"
    >
      <div class="dialog_wrap">
        <div class="dialog_title">
          {{ langSet == "cn" ? "展商认证" : "Exhibition Certification" }}
        </div>
        <el-form
          :model="companyForm"
          :rules="companyFormRules"
          ref="companyForm"
          label-width="80px"
          label-position="top"
          class="personal_form"
        >
          <el-form-item
            :label="langSet == 'cn' ? '账号' : 'Account number'"
            prop="username"
          >
            <el-input
              v-model="companyForm.username"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="langSet == 'cn' ? '密码' : 'Password'"
            prop="password"
          >
            <el-input
              v-model="companyForm.password"
              type="password"
              placeholder="请输入"
            ></el-input>
            <div class="dialog_tips">
              {{
                langSet == "cn"
                  ? "请向您企业展会负责人所要验证信息"
                  : "Please request verifcation information from the person in charge of your company's exhibition"
              }}
            </div>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              v-prevent-re-click
              @click="submitCompanyForm('companyForm')"
              >{{ langSet == "cn" ? "提交" : "Submit" }}</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>
  
<script>
import navMenu from "../components/navMenu.vue";
import moblienavMenu from "../components/moblienavMenu.vue";
import countdown from "../components/countdown.vue";
import { sdkClick } from "../sdk/useSdk";
import {
  getWebsiteBase,
  getWebsite,
  userInfo,
  logout,
  companyAttestation,
} from "@/api/api";
export default {
  components: {
    navMenu,
    moblienavMenu,
    countdown,
  },
  props: {
    isNav: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      langSet: "",
      dialogVisible: false,
      isLogin: true,
      memberid: 0,
      options: [
        {
          value: "cn",
          label_cn: "中文",
          label_en: "Chinese",
          label_jp: "中国語",
        },
        {
          value: "en",
          label_cn: "英文",
          label_en: "English",
          label_jp: "英語",
        },
        // {
        //   value: "Jp",
        //   label_cn: "日文",
        //   label_en: "Japanese",
        //   label_jp: "日语",
        // },
      ],
      value: "",
      isShowMenu: true,
      showtype: "",
      logo: "",
      logoH5: "",
      user: require("../assets/user.png"),
      countDownNum: "",
      flag: "",
      userInfo: {},
      isShowInfo: false,
      dialogVisibleEx: false,
      companyForm: {
        username: "",
        password: "",
      },
      companyFormRules: {
        username: [
          {
            required: true,
            message: "请输入账号/please enter account number",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码/please enter password",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    this.memberid = localStorage.getItem("memberid");
    this.uuid = localStorage.getItem("uuid");
    this.loggedIn();
    // 设置语言
    this.value = this.$language;
    this.langSet = this.$language;
    if (!this.isNav) {
      this.value = "Jp";
    }
    // 25.9.24 获取个人资料 dxm
    this.flag = localStorage.getItem("Flag") || "";
    if (this.flag == "isLogin") {
      this.getUserInfo();
    }
    // this.getData();
    //25.9.24 获取网站基本信息 dxm
    this.getWebsite();
    this.getCountNum();
  },
  created() {},
  methods: {
    handleDialogVisible() {
      this.dialogVisibleEx = true;
    },
    showInfo() {
      this.isShowInfo = !this.isShowInfo;
    },
    async getUserInfo() {
      try {
        const res = await userInfo();
        this.userInfo = res.data;
        localStorage.setItem("userInfo", JSON.stringify(this.userInfo));
      } catch (error) {
        let loginRes = {
          token: null,
          isLogin: false,
        };
        this.$store.commit("userStatus", loginRes);
        localStorage.clear();
        setTimeout(() => {
          location.reload();
        }, 500);
      }
    },
    changebtn() {
      this.showtype = 0;
      this.dialogVisible = true;
    },
    changjqqd() {
      this.showtype = 1;
      this.dialogVisible = true;
    },
    login() {
      this.$router.push({
        name: "login",
      });
    },
    showMenu() {
      this.isShowMenu = !this.isShowMenu;
    },
    closeMenu() {
      this.isShowMenu = true;
    },
    getWebsite() {
      getWebsiteBase()
        .then((res) => {
          if (res.code == 1) {
            let metaData = {
              title: res.data.shop_name,
              keywords: res.data.pc_keywords,
              desc: res.data.pc_desc,
            };
            localStorage.setItem("metaData", JSON.stringify(metaData));
            this.logo = res.data.web_logo;
            this.logoH5 = res.data.h5_favicon;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getCountNum() {
      let data = {
        type: "home",
      };
      const res = await getWebsite(data);
      this.countDownNum = new Date(res.data.count_down).getTime();
    },
    getData() {
      let data = this.$qs.stringify({
        memberid: this.memberid,
        uuid: this.$uuid,
      });
      getUser(data)
        .then((res) => {
          console.log(res);
          if (res.data.errno == 0) {
            this.userInfo = res.data.rst;
            let improve = localStorage.getItem("improve");
            if (
              !this.userInfo.nickname ||
              !this.userInfo.country ||
              !this.userInfo.nickname ||
              !this.userInfo.nickname ||
              this.userInfo.nickname == "请填写姓名" ||
              this.userInfo.nickname == "请填写手机号" ||
              this.userInfo.nickname == "请填写公司名称" ||
              this.userInfo.country == "请填写国家"
            ) {
              localStorage.setItem("improve", true);
            } else {
              localStorage.setItem("improve", false);
              if (improve == null) {
                this.$router.push({ path: "/pair" });
              } else if (improve && improve !== "false") {
                this.$router.push({ path: "/pair" });
              }
            }
          } else {
            if (localStorage.getItem("Flag")) {
              localStorage.removeItem("Flag");
              location.reload();
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    changeLang(e) {
      if (this.value !== e && e === "cn") {
        sdkClick("其他功能区", "切换语言-中文");
      } else if (this.value !== e && e === "en") {
        sdkClick("其他功能区", "切换语言-英文");
      } else if (this.value !== e && e === "Jp") {
        sdkClick("其他功能区", "切换语言-日文");
      }
      this.value = e;
      if (this.$language == "cn") {
        // 中文设置
        if (e == "Jp") {
          this.$router.push({
            path: "/Japanese",
          });
          return false;
        } else if (e == "en") {
          if (!this.isNav) {
            this.value = "Jp";
          } else {
            this.value = "cn";
          }
          window.open("https://www.apichina.com.cn/en/", "_blank");
          return false;
        } else {
          this.$router.push({
            path: "/",
          });
          location.reload();
          return false;
        }
      } else if (this.$language == "en") {
        // 英文设置
        if (e == "Jp") {
          this.$router.push({
            path: "/Japanese",
          });
          return false;
        } else if (e == "cn") {
          if (!this.isNav) {
            this.value = "Jp";
          } else {
            this.value = "en";
          }
          window.open("https://www.apichina.com.cn/", "_blank");
          return false;
        } else {
          this.$router.push({
            path: "/",
          });
          location.reload();
          return false;
        }
      }
    },
    toLink(path) {
      this.$router.push({
        path,
      });
    },
    loggedIn() {
      this.memberid = localStorage.getItem("memberid");
      if (this.memberid == 0 || this.memberid == null) {
        this.isLogin = true;
      } else {
        this.isLogin = false;
      }
    },
    //退出登录
    async logOut() {
      try {
        await this.$confirm("确定要退出吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
        await logout();
        this.$message.success("退出成功");
        let loginRes = {
          token: null,
          isLogin: false,
        };
        this.$store.commit("userStatus", loginRes);
        localStorage.clear();
        setTimeout(() => {
          this.$router.push({
            path: "/",
          });
          location.reload();
        }, 2000);
      } catch (err) {
        if (err !== "cancel") {
          this.$message.error("退出失败: " + err.message);
        }
      }
    },
    async submitCompanyForm(formName) {
      this.loading = true;
      try {
        const valid = await new Promise((resolve) => {
          this.$refs[formName].validate(resolve);
        });
        if (valid) {
          let res = await companyAttestation(this.companyForm);
          if (res.code == 1) {
            this.$message.success("认证成功");
          } else {
            this.$message.warning(res.msg);
          }
          this.dialogVisibleEx = false;
        } else {
          this.$message.error("认证失败，请检查输入信息");
          return false;
        }
        this.loading = false;
      } catch (err) {
        this.$message.error(`提交失败: ${err.message}`);
        this.loading = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .el-dialog__wrapper {
  height: 100vh;
  background: rgba(0, 0, 0, 0.4);
  z-index: 99999;
}
/deep/ .exhibition_dialog {
  height: 387px;
  margin-top: 0;
  background: #1d2379;
  border-radius: 20px;
  .el-dialog__body {
    color: #fff;
    padding: 0 30px;
  }
  .dialog_title {
    font-size: 18px;
    line-height: 25px;
    font-weight: 500;
    text-align: center;
    margin-bottom: 20px;
  }
  .el-form-item__label {
    color: #fff;
    font-size: 16px;
    line-height: 22px;
  }
  .el-button--primary {
    width: 180px;
    font-size: 16px;
    background: #e62344;
    border-color: #e62344;
    border-radius: 5px;
    margin: 0 auto;
    display: block;
  }
  .el-form-item.is-required:not(.is-no-asterisk)
    .el-form-item__label-wrap
    > .el-form-item__label:before,
  .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
    display: none;
  }
  .el-form-item__error {
    top: 10px;
    left: auto;
    right: 15px;
  }
  .dialog_tips {
    padding-top: 10px;
    line-height: 20px;
  }
}
</style>
<style lang="scss">
.dialog {
  width: 350px;
  height: 288px;
  background: #ffffff;
  border-radius: 12px;
  margin: auto;
  display: flex;
}
.dialog_img {
  width: 151px;
  height: 160px;
}
.dialog_txt {
  margin-top: 40px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 18px;
  color: #333333;
}
.mobile-header-box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 10;
}
.header_box_slide {
  width: 100%;
  background: #f9f9f9;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);
  opacity: 0.9;
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 99;
}
.header_slide {
  width: 1280px;
  height: 98px;
  margin: 0 auto;
  padding: 0 70px 0 100px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
.header_box {
  width: 100%;
  background: #ffffff;
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 99;
  backdrop-filter: blur(4px);
  box-shadow: 0 -8px 10px 5px rgba(0, 0, 0, 0.1);
}
.height {
  height: 78px;
}
.header {
  width: 1440px;
  height: 78px;
  margin: 0 auto;
  padding: 0 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  box-sizing: border-box;
}
.count-wrap {
  width: 200px;
  height: 108px;
  padding: 0 12px 0 15px;
  box-sizing: border-box;
  color: #fff;
  font-weight: 500;
  font-size: 28px;
  line-height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #1d2379;
  border-radius: 0px 0px 20px 20px;
  .count-num {
    width: 80px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: Montserrat, Montserrat;
    font-weight: bold;
    font-size: 44px;
    color: #1d2379;
    background: url("../assets/c_bg.jpg") no-repeat;
    background-size: 100%;
  }
  .num {
    margin-top: 10px;
  }
}
.count-en-warp {
  flex-wrap: wrap;
  justify-content: center;
  padding-top: 9px;
  font-size: 22px;
  line-height: 20px;
  .num {
    margin-top: 0;
  }
}
.header-logo {
  width: 75px;
  height: 75px;
  margin-right: 17px;
  margin-left: 30px;
  cursor: pointer;
}
.header-logo img {
  width: 100%;
  height: 100%;
}
.header-right {
  width: 208px;
  font-size: 18px;
  color: #fff;
  text-align: center;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  .right-icon {
    width: 16px;
    height: 16px;
  }
  .lang {
    background: #cac28a;
    border-radius: 30px;
    width: 46%;
    display: flex;
    height: 38px;
    line-height: 30px;
    padding: 5px 10px;
    box-sizing: border-box;
    p {
      width: 50%;
      border-radius: 30px;
      .cur {
        background: #fff;
        color: #cac28a;
      }
    }
  }
  .header-user {
    width: 38px;
    height: 38px;
    margin-left: 10px;
  }
  .header_login {
    width: 109px;
    height: 49px;
    color: #1d2379;
    cursor: pointer;
    background: rgba(255, 255, 255, 0.3);
    border-radius: 10px;
    img {
      width: 40px;
      height: 40px;
      margin-right: 5px;
      border-radius: 50%;
    }
    .el-icon-arrow-right {
      transition: all 0.3s;
    }
  }
  .show .el-icon-arrow-right {
    transform: rotate(90deg);
  }
  .login_wrap {
    width: 360px;
    height: auto;
    background: #fff;
    position: absolute;
    top: 78px;
    right: 0;
    font-size: 14px;
    color: #898b9b;
    line-height: 20px;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
    > div {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px;
    }
    .login_top {
      height: 96px;
      color: #fff;
      background: #004190;
      box-sizing: border-box;
      img {
        width: 65px;
        height: 65px;
        border-radius: 50%;
        margin-right: 11px;
      }
      .login_info {
        flex: 1;
        text-align: left;
        .name {
          font-size: 18px;
          font-weight: 500;
          margin-bottom: 5px;
          span {
            font-size: 15px;
            margin-left: 10px;
          }
        }
      }
    }
    .login_middle {
      margin: 0 14px;
      padding: 17px 10px;
      border-bottom: 1px solid #eee;
      > div {
        width: 80px;
        min-height: 80px;
        padding: 13px 0;
        box-sizing: border-box;
        text-align: center;
        border-radius: 8px;
        cursor: pointer;
        transition: all 0.3s;
        .icon_a {
          display: none;
        }
        .icon_d {
          display: block;
        }
        &:hover {
          color: #fff;
          background: #719ed5;
          .icon_d {
            display: none;
          }
          .icon_a {
            display: block;
          }
        }
      }
      img {
        width: 26px;
        margin: 0 auto 8px;
      }
    }
    .login_bottom {
      padding: 15px 24px;
      > div {
        cursor: pointer;
      }
      .text {
        color: #004190;
      }
    }
  }
}

.el-col {
  border-radius: 0 !important;
}
.navcenter {
  width: calc(100% - 550px);
}
.languagewrap {
  width: 140px;
  height: 38px;
  position: relative;
  color: #44435a;
  display: flex;
  background: #ffffff;
  border-radius: 22px;
  border: 1px solid #adb4c7;
  cursor: pointer;
  .right-icon {
    width: 16px;
    height: 16px;
    position: absolute;
    top: 11px;
    left: 12px;
  }
}
.languagewrap .el-select .el-input__inner {
  height: 38px;
  color: #44435a;
  border: 0 none !important;
  padding: 0 12px 0 36px;
  border-radius: 7px;
  margin-top: 0;
  background: transparent;
}
.languagewrap .el-select {
  position: absolute;
}
.languagewrap .el-select .el-input .el-select__caret {
  color: #001a33;
}
// .languagewrap .el-input__suffix {
//   display: none;
// }

.dropdown {
  background-color: rgba($color: #000000, $alpha: 0.8);
  border: 1px solid rgba($color: #000000, $alpha: 0.8);
  color: #333;
  font-size: 14px;
  padding: 8px 12px;
}
.el-popper {
  margin-top: 8px !important;
}
.dropdown {
  border-color: rgba($color: #000000, $alpha: 0.8);
  background-color: rgba($color: #000000, $alpha: 0.8);
  box-sizing: border-box;
  z-index: 99999;

  .el-select-dropdown__item {
    color: rgba($color: #ffffff, $alpha: 0.8);
  }
  .el-popper .popper__arrow {
    border-bottom-color: rgba($color: #000000, $alpha: 0.8);
  }
  .el-popper .popper__arrow::after {
    border-bottom-color: rgba($color: #000000, $alpha: 0.8);
  }

  .el-select-dropdown__item.hover,
  .el-select-dropdown__item:hover {
    color: #fff;
    background-color: rgba($color: #000000, $alpha: 0.8);
  }
  .el-select-dropdown__item.selected {
    color: #fff;
  }
  .popper__arrow {
    border-bottom-color: rgba($color: #000000, $alpha: 0.8) !important;
  }
  .popper__arrow::after {
    border-bottom-color: rgba($color: #000000, $alpha: 0.8) !important;
  }
}

.dropdown_sel {
  background-color: #fff;
  box-shadow: 0px 0px 4px 0px rgba(255, 255, 255, 0.12);
  border: 1px solid #fff;
  color: #2c2c2e;
  font-size: 14px;
  padding: 5px;
}

.dropdown_sel {
  background-color: #fff;
  box-shadow: 0px 5px 20px 0px rgba(0, 26, 51, 0.16);
  box-sizing: border-box;
  z-index: 99999;
  border-radius: 12px;

  .el-select-dropdown__item {
    color: #2c2c2e;
  }
  .el-popper .popper__arrow {
    border-bottom-color: #f4f4f4;
  }
  .el-popper .popper__arrow::after {
    border-bottom-color: #f4f4f4;
  }

  .el-select-dropdown__item.hover,
  .el-select-dropdown__item:hover {
    color: #1d2379;
    background: rgba(29, 35, 121, 0.1);
    border-radius: 8px;
  }
  .el-select-dropdown__item.selected {
    color: #1d2379;
    border-radius: 8px;
  }
  .popper__arrow {
    display: none;
    border-bottom-color: #f4f4f4 !important;
  }
  .popper__arrow::after {
    border-bottom-color: #f4f4f4 !important;
  }
}

.showLang {
  font-family: ArialMT;
  font-size: 14px;
  margin-left: 8px;
}

.mobile-header {
  display: none;
}
@media only screen and (max-width: 1440px) {
  .header {
    width: 1280px;
    padding: 0;
    .count-wrap {
      width: 160px;
      height: 98px;
      font-size: 18px;
      padding: 0 10px;
    }
    .header-logo {
      margin: 0 17px 0 5px;
    }
  }
  .navcenter {
    width: calc(100% - 480px);
  }
}
@media only screen and (max-width: 1280px) {
  .header {
    width: 100%;
    padding: 0 20px;
    .count-wrap {
      font-size: 17px;
    }
  }
}
@media only screen and (max-width: 767px) {
  .header {
    display: none;
  }
  .header_box_slide {
    display: none;
  }
  .height {
    height: 1.69rem;
  }
  .mobile-header {
    color: #fff;
    display: block;
    height: 1.69rem;
    text-align: center;
    line-height: 1.69rem;
    background: #fff;
    display: flex;
    align-items: center;
    .header-logo {
      width: 1.5rem;
      height: 1.5rem;
      margin-left: 0.29rem;
    }
    .header-menu {
      img {
        width: 0.57rem;
        height: 0.5rem;
      }
      i {
        font-size: 26px;
        position: relative;
        top: 5px;
        right: -4px;
      }
    }
    .mobile-header-right {
      display: flex;
      height: 0.88rem;
      align-items: center;
      padding-right: 0.2rem;
      justify-content: space-between;
      display: none;
      .language {
        width: 1.6rem;
        height: 0.48rem;
        display: flex;
        line-height: 0.4rem;
        background: #666;
        border-radius: 24px;
        padding: 0.05rem;
        box-sizing: border-box;
        z-index: 99;
        p {
          flex: 1;
          font-size: 12px;
          height: 100%;
          text-align: center;
        }
        .act {
          color: #000;
          background: #fff;
          border-radius: 14px;
        }
      }
    }
  }
  .count-wrap {
    width: 2.69rem;
    height: 1.12rem;
    font-size: 0.24rem;
    background: #1d2379;
    border-radius: 0.27rem;
    margin-right: 0.38rem;
    padding: 0 0.1rem;
    .count-num {
      width: 0.92rem;
      height: 0.69rem;
      margin-top: 5px;
    }
  }
}
</style>
